module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "font-size-title font-weight-regular mb-3"
  }, [_vm._v("選擇店家")]), _vm._v(" "), _c('div', _vm._l((_vm.storeClassList), function(storeClass, i) {
    return _c('div', {
      key: ("store-class-" + i),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      domProps: {
        "textContent": _vm._s(storeClass.name)
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    })])
  }), 0)]), _vm._v(" "), _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.setting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.setting.choose),
      callback: function($$v) {
        _vm.$set(_vm.setting, "choose", $$v)
      },
      expression: "setting.choose"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-efe12f4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/nd-multi-select-listbox.vue
// module id = 2564
// module chunks = 1